export const SIGN_IN_START = 'SIGN_IN_START';
export const SIGN_OUT_START = 'SIGN_OUT_START';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_ERROR = 'SIGN_IN_ERROR';
export const SIGN_OUT_END = 'SIGN_OUT_END';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';

export const SET_USER_COMPANIES = 'SET_USER_COMPANIES';

export const CLOSE_ACTIVE_SHIPMENT = 'CLOSE_ACTIVE_SHIPMENT';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export const CLEAR_ALL_DATA = 'CLEAR_ALL_DATA';
export const REMOVE_ESCALATIONS = 'REMOVE_ESCALATIONS';

export const UPDATE_QUERY = 'UPDATE_QUERY';
export const UPDATE_IGNORE_PORTALS = 'UPDATE_IGNORE_PORTALS';
export const FETCH_WATCHERS_START = 'FETCH_WATCHERS_START';
export const FETCH_WATCHERS_SUCCESS = 'FETCH_WATCHERS_SUCCESS';
export const FETCH_WATCHERS_ERROR = 'FETCH_WATCHERS_ERROR';
export const SET_MAP_DRIVERS = 'SET_MAP_DRIVERS';
export const SET_SHIPMENT_GROUPS = 'SET_SHIPMENT_GROUPS';
export const UPDATE_SHIPMENT_GROUP_AGGS = 'UPDATE_SHIPMENT_GROUP_AGGS';
export const UPDATE_SHIPMENT_GROUPS_AGGS = 'UPDATE_SHIPMENT_GROUPS_AGGS';
export const SET_SELECTED_GROUPS = 'SET_SELECTED_GROUPS';
export const REMOVE_GROUP = 'REMOVE_GROUP';
export const EDIT_GROUP = 'EDIT_GROUP';
export const ADD_NEW_GROUP = 'ADD_NEW_GROUP';
export const TOGGLE_GROUP = 'TOGGLE_GROUP';
export const FETCH_SHIPMENT_START = 'FETCH_SHIPMENT_START';
export const FETCH_LOCATION_ROUTE_BUILT_SUCCESS = 'FETCH_LOCATION_ROUTE_BUILT_SUCCESS';
export const FETCH_EXPECTED_ROUTE_BUILT_SUCCESS = 'FETCH_EXPECTED_ROUTE_BUILT_SUCCESS';
export const SET_SHIPMENT_EVENTS = 'SET_SHIPMENT_EVENTS';
export const ZOOM_INTO = 'ZOOM_INTO';
export const FIT_BOUNDS_SET = 'MAP_STATE_FIT_BOUNDS_SET';
export const SELECT_DEVICE_EVENT = 'SELECT_DEVICE_EVENT';
export const CLEAR_SELECTED_DEVICE_EVENT = 'CLEAR_SELECTED_DEVICE_EVENT';
export const TOGGLE_GEOFENCES = 'TOGGLE_GEOFENCES';
export const TOGGLE_WEATHER_OPTICS = 'TOGGLE_WEATHER_OPTICS';
export const TOGGLE_DEVICE_CHART = 'TOGGLE_DEVICE_CHART';
export const CLOSE_DEVICE_CHART = 'CLOSE_DEVICE_CHART';
export const OPEN_DEVICE_CHART = 'OPEN_DEVICE_CHART';
export const TOGGLE_DEVICE_CONTROL = 'TOGGLE_DEVICE_CONTROL';
//map interactions
export const SET_SELECTED_COORDINATES = 'SET_SELECTED_COORDINATES';
export const CLEAR_SELECTED_COORDINATE = 'CLEAR_SELECTED_COORDINATE';
export const SET_SELECTED_SENSOR_PING = 'SET_SELECTED_SENSOR_PING';
export const CLEAR_SELECTED_SENSOR_PING = 'CLEAR_SELECTED_SENSOR_PING';
export const SET_HIGHLIGHTED_SENSOR_PING = 'SET_HIGHLIGHTED_SENSOR_PING';
export const CLEAR_HIGHLIGHTED_SENSOR_PING = 'CLEAR_HIGHLIGHTED_SENSOR_PING';
export const TOGGLE_ERRANT_PINGS_MAP_TOOL = 'TOGGLE_ERRANT_PINGS_MAP_TOOL';

export const SET_HIGHLIGHTED_SHIPMENT_EVENT = 'SET_HIGHLIGHTED_SHIPMENT_EVENT';
export const CLEAR_HIGHLIGHTED_SHIPMENT_EVENT = 'CLEAR_HIGHLIGHTED_SHIPMENT_EVENT';

//errant pings
export const TOGGLE_ERRANT_PINGS = 'TOGGLE_ERRANT_PINGS';
export const SET_ERRANT_PINGS = 'SET_ERRANT_PINGS';
export const ADD_ERRANT_PING = 'ADD_ERRANT_PING';

export const UPDATE_SEGMENT_EVENT = 'UPDATE_SEGMENT_EVENT';

export const SET_EXPECTED_ROUTE = 'SET_EXPECTED_ROUTE';
export const CLEAR_EXPECTED_ROUTE = 'CLEAR_EXPECTED_ROUTE';
export const CHANGE_MOBILE_VIEW = 'CHANGE_MOBILE_VIEW';

//light events
export const SET_CRITICAL_ALERTS_LIST = 'SET_CRITICAL_ALERTS_LIST';
export const ADD_CRITICAL_ALERT = 'ADD_CRITICAL_ALERT';
export const UPDATE_CRITICAL_ALERT = 'UPDATE_CRITICAL_ALERT';
export const REMOVE_CRITICAL_ALERT = 'REMOVE_CRITICAL_ALERT';
export const MARK_CRITICAL_ALERT_AS_READ = 'MARK_CRITICAL_ALERT_AS_READ';
export const SET_FETCHED_VIA_HTTP = 'SET_FETCHED_VIA_HTTP';

//shipment 
export const CHOOSE_ACTIVE_SHIPMENT = 'CHOOSE_ACTIVE_SHIPMENT';

//map
export const HIDE_POPUP = 'HIDE_POPUP';
export const SHOW_POPUP = 'SHOW_POPUP';
export const SELECT_LOCATION = 'SELECT_LOCATION';
export const CLEAR_SELECTED_LOCATION = 'CLEAR_SELECTED_LOCATION';
export const SET_SELECTED_GEOFENCE = 'SET_SELECTED_GEOFENCE';
export const CLEAR_SELECTED_GEOFENCE = 'CLEAR_SELECTED_GEOFENCE';
export const MAP_CLICK = 'MAP_CLICK';
export const SEPARATED_PING_RECEIVED = 'SEPARATED_PING_RECEIVED';
export const SET_MAP_BOUNDS = 'NEW_BOUNDS';

//shipment map
export const TOGGLE_MAP_PLANNED_ROUTE = 'TOGGLE_MAP_PLANNED_ROUTE';
export const SET_MAP_PLANNED_ROUTE = 'SET_MAP_PLANNED_ROUTE';
export const TOGGLE_MAP_EXPECTED_ROUTE = 'TOGGLE_MAP_EXPECTED_ROUTE';
export const SET_MAP_EXPECTED_ROUTE = 'SET_MAP_EXPECTED_ROUTE';
export const CHANGE_SELECTED_ACCURATE_ROUTES = 'CHANGE_SELECTED_ACCURATE_ROUTES';
export const SET_LOGISTICS_ROUTE_CONTROLS = 'SET_LOGISTICS_ROUTE_CONTROLS';
export const CLEAR_SHIPMENT = 'CLEAR_SHIPMENT';
//event reasons
export const SET_EVENT_REASONS = 'SET_EVENT_REASONS';
